import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueInputMask from 'vue-inputmask'
// import { sync } from 'vuex-router-sync'

import '@/styles/index.scss'

Vue.use(VueInputMask.default)

// sync(store, router)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
